export const EMPTY_SECTION_SX = { backgroundColor: 'transparent', minHeight: '500px' } as const;

export const FIELD_LIST_SKELETON_COUNT = 5;
